import React, { Fragment, useState } from "react";
import ReactECharts from "echarts-for-react";
import styles from "Components/Dashboard/dashboard.module.scss";
import { Popover, Space, Spin, Typography } from "antd";
import { useAppDispatch, useAppSelector } from "store/hook";
import { getOption_firmware, ChartClick } from "../utils";
import { useIdentity } from "Components/Topology/queries";
import { Label, ChartContainer, DashCard } from "./Shared";
import { useNavigate } from "react-router-dom";
import { setFilter } from "Components/Topology/Device/deviceTableSlice";
import { param } from "cypress/types/jquery";

const { Text } = Typography;
const randomColor = () => {
  return "#" + Math.floor(Math.random() * 16777215).toString(16);
};

const color = [
  "#28a745",
  "#ffc107",
  "#343a40",
  "gray",
  "#0000FF",
  "#5599FF",
  "#C71585",
  "#FF88C2",
  "#7700BB",
  "#9F88FF",
  "#FF8800",
  "#00AAAA",
  "#66CDAA",
  "#668800",
  "#AA7700",
  "#DDAA00",
  "#FFDD55",
  "#666666",
  "#AAAAAA",
  ...Array.from({ length: 100 }, () => randomColor()),
];
// 預設韌體版本數據 (未使用)
const defaultFirmware = { firmware: { Firmware: 0 } };

// React.memo 用於性能優化，僅在 props 改變時重新渲染
const Firmware_Pie = React.memo(() => {
  // 使用 Redux  狀態管理 useAppSelector 取得 global 的 level, stateCid, loginCid 值
  const { level, stateCid, loginCid } = useAppSelector((status) => status.global);
  const { data, isLoading: loading, isFetching } = useIdentity(level, stateCid, loginCid);
  const [popVisible, setPopVisible] = useState(false); // 設定 韌體版本圖表卡片 是否可見 （預設false）
  const identityTable = data?.response?.device_identity || []; // 取得 數據設備詳細資訊 引入地圖圖表中 (數據名稱、座標、模組名稱等...)
  const navigate = useNavigate();
  const disp = useAppDispatch();
  const firmwareByModel =
    data?.response?.device_identity?.reduce((acc: any, cur) => {
      const model = cur.nodeInf.model; // model  獲取每台數據機設備 model名稱
      const firmware = `V${cur.obj.identity?.software_mcsv}` || "unknown";
      if (acc?.[model]) {
        if (acc?.[model]?.[firmware]) {
          acc[model][firmware] = [...acc[model][firmware], cur.nodeInf.id];
        } else {
          acc[model][firmware] = [cur.nodeInf.id];
        }
      } else {
        acc[model] = { [firmware]: [cur.nodeInf.id] };
      }
      return { ...acc };
    }, {}) || {};
  let defaultLabel: any[] = [["Firmware", 0]];
  let getOption_data: any = [];
  let label_arr: any = [];
  let color_index = 0;
  let firmwareMapping: any = {};

  const onChartClick = (params: ChartClick, label: string) => {
    const MCSV = firmwareMapping[params?.data?.name || label.toUpperCase()];
    const t: Record<string, string[]> = Object.values(firmwareByModel).reduce(
      (acc: Record<string, string[]>, curr: any) => {
        return { ...acc, ...curr };
      },
      {}
    );

    disp(setFilter({ name_or_id: t[MCSV] }));
    navigate("./overview");
  };
  // Firmware(韌體版本)  彈出卡片內容
  const lableContent = (
    <div style={{ maxWidth: "500px", display: "flex", flexDirection: "column" }}>
      {Object.keys(firmwareByModel).map((modelKey, modelIndex) => {
        const modelNumber = Object.entries(firmwareByModel[modelKey]).length;
        const modelColor = color.slice(color_index, color_index + modelNumber);
        color_index += modelNumber;
        //@ts-ignore
        const data = Object.entries(firmwareByModel[modelKey]).map(([key, value]) => {
          // readableMCSV ： 定義設備韌體 且格式化 若 true Vundefined 返回 NaN ；false 格式化設備
          // 韌體格式化 "014B00011133847E" =>  (格式化) => "V1.13-1133847E"
          const readableMCSV =
            key === "Vundefined" ? "NaN" : `V${(Number(key.slice(-8, -5)) / 100).toFixed(2)}-${key.slice(-8)}`;
          // 如果 name 一樣，echarts 就會當作同個 label，就會出現 label 顏色重複的錯誤，所以在 readableMCSV 最後加上 ${key} 作區隔
          const readableMCSV_chart_lable_name =
            key === "Vundefined"
              ? `NaN${value}`
              : `V${(Number(key.slice(-8, -5)) / 100).toFixed(2)}-${key.slice(-8)}${key}`;
          getOption_data.push([
            readableMCSV_chart_lable_name,
            //@ts-ignore
            value.length,
          ]);
          firmwareMapping = { ...firmwareMapping, [readableMCSV_chart_lable_name]: key };

          // 計算 label 長度，判斷是否顯示 <span>...</span>
          label_arr.push([
            readableMCSV,
            //@ts-ignore
            value.length,
          ]);

          return [
            readableMCSV,
            //@ts-ignore
            value.length,
          ];
        });

        parseInt(modelKey.slice(-5), 16);
        // Firmware 彈出卡片的提示文字 modelKey == 數據機名稱
        const tooltip = Object.entries(firmwareByModel[modelKey]).map(([key]) => {
          // firmwareByModel 依序將 key 進行 判斷 若為 Vundefined 回傳 ""(空字串) ；
          // 為false 回傳 key的後五碼並轉為數字 從16進位轉為十進位
          const number = key === "Vundefined" ? "" : parseInt(key.slice(-5), 16);
          return [`${number}`];
        });
        return (
          //TODO: 新增 Fragment key={modelKey} 包住 Text 與 Label 可消除錯誤警告
          <Fragment key={modelKey}>
            {/* 新增這一行 */}
            <Text strong>{modelKey}</Text>
            <Label
              legendHeight={{ height: "auto" }}
              //  @ts-ignore
              devicestatic={data}
              //  @ts-ignore
              tooltip={tooltip}
              color={modelColor}
              // FIXME: Firmware 資訊 卡片彈出事件，點擊韌體版本並跳轉到 /overview "待開發"
              // onChartClick={onChartClick}
            />
          </Fragment>
        );
      })}
    </div>
  );
  const onEvents = {
    click: onChartClick,
  };
  return (
    <DashCard title={"Firmware"}>
      {/* 當 "正在載入" 與 "正在獲取資料" 其中一個為ture 顯示 LoadingSpin icon 
          反之，結果為false 時 顯示圖形並顯示資訊欄(滑動顯示) */}
      {loading || isFetching ? (
        <Fragment>
          {/* <Label devicestatic={Object.entries(defaultFirmware.firmware)} /> */}
          <Spin className={styles.loadingSpin} />
        </Fragment>
      ) : (
        <Fragment>
          {
            <Space>
              {/* 韌體版本圖表卡片 */}
              <Popover
                placement="left"
                content={lableContent}
                trigger="hover"
                visible={popVisible}
                onVisibleChange={(newVisible: boolean) => setPopVisible(newVisible)}
              >
                <Label color={color.slice(0, getOption_data.length)} devicestatic={label_arr.slice(0, 2)} />
                {label_arr.length >= 2 && <span>...</span>}
              </Popover>
            </Space>
          }
          {/* identityTable 資料不等於 0 時 顯示 Firmware(韌體) 圖表 */}
          {identityTable.length !== 0 && (
            <ChartContainer sum={identityTable.length}>
              <ReactECharts
                className={styles.pie__chart}
                option={getOption_firmware(getOption_data, color.slice(0, getOption_data.length))}
                /* notMerge: 不合併配置 (預設值: false)
                    true: 新的配置將與之前的配置進行合併，保留之前的配置，僅更新有變化的部分。
                    false: 新的配置將完全替換之前的配置，不進行合併，完全更新整個配置。*/
                notMerge={true}
                /* lazyUpdate: 延遲更新 (預設值: false)
                    true: 延遲更新圖表，直到下一次事件循環開始，合併多次配置更新，提高性能。
                    false: 立即更新圖表，不延遲更新，即時反映最新的配置變化。
                */
                lazyUpdate={true}
                theme={"theme_name"}
                // onEvents={onEvents}
              />
            </ChartContainer>
          )}
        </Fragment>
      )}
    </DashCard>
  );
});

export default Firmware_Pie;
